import { uri } from '../../api-endpoint';
import { deleteTemplateFn } from '../common';

export const deleteModelImage = (token: string) => (
  modelId: number,
  imageId: number
) => deleteTemplateFn(token, uri.modelImageById(modelId, imageId));
